const liveStreaming = [
    {
        path: "/download",
        name: "下载",
        component: () => import("@views/Live/androidDownload.vue"),
        meta: {
          title: "下载",
          singleHead: true
        },
      }
      
]
export default liveStreaming